const ENERGY_LABEL_LEADS = {
  title: 'Energiamerkintä-liidit',
  description: 'Yleiskatsaus energiamerkinnän liideihin',
  searchPlaceholder: 'Hae liidejä …',
  emptyState: 'Liidejä ei löytynyt.',
  importButton: 'Tuo Excel',
  importError: 'Tiedostoa ei voitu tuoda.',
  importEmpty: 'Tiedostossa ei ollut rivejä.',
  importSummary: 'Tuotiin {imported}/{received} riviä.',
  importRejected: 'Hylätyt rivit:',
  importRow: 'Rivi {row}',
  importErrors: {
    required: '{field} puuttuu',
    invalid: '{field} ei kelpaa',
    // more precise than the generic wording, worth its own key
    organizationNumber_invalid: 'Y-tunnuksessa on oltava 9 numeroa',
  },
  importFields: {
    contactPerson: 'Yhteyshenkilö',
    organizationNumber: 'Y-tunnus',
    contactEmail: 'Sähköposti',
    contactPhone: 'Puhelin',
    companyName: 'Yrityksen nimi',
  },
  assignToMe: 'Ota itselleni',
  assignToMeNeedsEnovaGuid:
    'Käyttäjältäsi puuttuu Enovan henkilökohtainen GUID, joten et voi ottaa liidejä.',
  backToList: 'Takaisin liideihin',
  unassigned: 'Ei määritetty',
  loadError: 'Liidien haku epäonnistui.',
  assignError: 'Liidin määrittäminen epäonnistui.',
  notFound: 'Liidiä ei löytynyt.',
  importNotImplemented: 'Excel-tuontia ei ole vielä toteutettu.',
  commentSaveError: 'Muistiinpanon tallennus epäonnistui.',
  commentSaved: 'Muistiinpano tallennettu.',
  daysAgo: '{count} päivää sitten',
  missingAddress: 'Osoite puuttuu',
  deleteConfirmTitle: 'Poista liidi',
  deleteConfirmMessage:
    'Haluatko varmasti poistaa tämän liidin? Toimintoa ei voi perua.',
  deleteError: 'Liidin poisto epäonnistui.',
  archiveError: 'Liidin arkistointi epäonnistui.',
  blockError: 'Liidiä ei voitu estää.',
  blockNotYours: 'Vain liidille osoitettu neuvoja voi estää sen.',
  blockWrongStatus: 'Liidin voi estää vain katselmuksen ollessa käynnissä.',
  archiveConfirmTitle: 'Arkistoi liidi',
  archiveConfirmMessage:
    'Haluatko varmasti arkistoida tämän liidin? Se merkitään arkistoiduksi ja poistuu avoimista.',
  archiveNotAllowed: 'Valmista liidiä ei voi arkistoida.',
  assignWrongStatus:
    'Liidin voi ottaa vain kun sen tila on Lomake täytetty, Osoitettu neuvojalle, Estetty tai Tiedot puutteelliset.',
  actions: {
    archive: 'Arkistoi',
    block: 'Estä',
    unblock: 'Poista esto',
  },
  lifecycle: {
    title: 'Elinkaari',
    steps: {
      imported: 'Liidi tuotu',
      created: 'Luotu — lomake lähetetty asiakkaalle',
      formCompleted: 'Asiakas valmis — valmis neuvonantajalle',
      inspectionStarted: 'Osoitettu neuvojalle',
      inspectionCompleted: 'Neuvonantaja valmis',
      completed: 'Energiatodistus myönnetty',
    },
  },
  building: {
    title: 'Rakennus',
    buildingNumber: 'Rakennusnumero',
    buildingType: 'Rakennustyyppi',
    none: 'Liidiin ei ole vielä liitetty rakennusta.',
    open: 'Avaa rakennus',
  },
  energyLabel: {
    title: 'Energiatodistus',
    grade: 'Energialuokka',
    issued: 'Myönnetty',
    openCertificate: 'Avaa todistus',
    complete: 'Viimeistele liidi',
    completeHelp:
      'Merkitsee liidin valmiiksi ja lähettää energiatodistuksen sähköpostilla yhteyshenkilölle',
    completeError: 'Liidin viimeistely epäonnistui.',
  },
  inspection: {
    title: 'Katselmus',
    name: 'Nimi',
    date: 'Katselmuksen päivä',
    readSubmitted: 'Lue lähetetyt tiedot',
    open: 'Avaa katselmus',
    create: 'Luo rakennuskatselmus',
    createAgain: 'Luo uusi rakennuskatselmus',
    noLead: 'Liidiä ei voitu ladata.',
    fixErrorsFirst: 'Korjaa ensin yllä olevien tarkistusten {count} virhettä.',
    createHint:
      'Katselmus luodaan yllä olevasta lomakkeesta, vakioarvoilla siellä missä asiakas ei vastannut.',
    created: 'Rakennuskatselmus on luotu.',
    noBuilding: 'Liitä ensin rakennus liidiin.',
    noSubmission: 'Liidiin ei ole vielä liitetty lähetettyä lomaketta.',
    createError: 'Rakennuskatselmusta ei voitu luoda.',
    exists: 'Tälle liidille luotiin juuri rakennuskatselmus.',
    filledCount: '{count} arvoa täytettiin vakioarvoilla.',
  },
  filters: {
    allOpen: 'Kaikki avoimet',
    waitingCustomer: 'Odottaa asiakasta',
    readyForInspector: 'Valmis neuvonantajalle',
    mine: 'Omat tapaukset',
    completed: 'Valmiit',
    stopped: 'Pysäytetyt',
    archived: 'Arkistoidut',
  },
  columns: {
    contactPerson: 'Yhteyshenkilö',
    organizationNumber: 'Y-tunnus',
    address: 'Osoite',
    status: 'Tila',
    consultant: 'Neuvonantaja',
    created: 'Luotu',
    actions: 'Toiminto',
  },
  reminder: {
    send: 'Lähetä muistutus',
    sent: 'Muistutus lähetetty',
    help: 'Lähettää lomakelinkin uudelleen samalla määräajalla',
    noDeadline:
      'Liidillä ei ole vielä määräaikaa — lähetä ensin ensimmäinen ilmoitus',
    error: 'Muistutusta ei voitu lähettää.',
  },
  status: {
    imported: 'Tuotu',
    created: 'Luotu',
    formCompleted: 'Lomake täytetty',
    inspectionStarted: 'Osoitettu neuvojalle',
    inspectionCompleted: 'Katselmus valmis',
    completed: 'Energiatodistus myönnetty',
    blocked: 'Estetty',
    notEnoughInformation: 'Tiedot puutteelliset',
    cancelled: 'Arkistoitu',
    unknown: 'Tuntematon',
  },
  detail: {
    companyName: 'Yrityksen nimi',
    internalComment: 'Sisäinen muistiinpano',
    internalCommentPlaceholder: 'Näkyy vain meille, ei koskaan asiakkaalle',
    contactSection: 'Yhteystiedot',
    contactPerson: 'Yhteyshenkilö',
    phone: 'Puhelin',
    email: 'Sähköposti',
    companySection: 'Yritys',
    organizationNumber: 'Y-tunnus',
    streetName: 'Kadunnimi',
    houseNumber: 'Talon numero',
    houseLetter: 'Kirjain',
    postalCode: 'Postinumero',
    city: 'Postitoimipaikka',
    mpidsSection: 'Mittauspisteen tunnukset',
    noMpids: 'Mittauspisteen tunnuksia ei ole rekisteröity',
    status: 'Tila',
    formSection: 'Asiakaslomake',
    formLink: 'Asiakkaalle lähetettävä linkki',
    copyLink: 'Kopioi linkki',
    linkCopied: 'Linkki kopioitu.',
    formStatus: 'Lomakkeen tila',
    formNotStarted: 'Ei vielä avattu',
    formDraft: 'Kesken',
    formSubmitted: 'Lähetetty',
  },
};

export default ENERGY_LABEL_LEADS;
